module.exports = __webpack_public_path__ + "img/registration.a828815e.svg";